export enum MixStageEnum {
  Pending = 1,
  InProgress = 2,
  Completed = 3,
  ResetToInProgress = 4,
}
